export type DateRange = {
	dateStart: Date | null;
	dateEnd: Date | null;
};

export const isDateInRange = (date: Date, range: DateRange): boolean => {
	const dateStart = range?.dateStart?.getTime() ?? 0;
	const dateEnd = range?.dateEnd?.getTime() ?? 0;
	const dateValue = date.getTime();
	return dateValue >= dateStart && dateValue <= dateEnd;
};
